/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreWorkloadSubtaskDto } from '../../models/core-workload-subtask-dto';

export interface ProjectSubtasksControllerGetWorkloadData$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
}

export function projectSubtasksControllerGetWorkloadData(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerGetWorkloadData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreWorkloadSubtaskDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerGetWorkloadData.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreWorkloadSubtaskDto>>;
    })
  );
}

projectSubtasksControllerGetWorkloadData.PATH = '/o2-core/project-subtasks/{tenant}/workload';
